import { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

const DeleteConfirmationModal = ({ handleClose, show, rowData, onDelete, numOfRows }) => {
  
    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title
                    // className='delete-modal-title'
                    style={{ color: '#c02d2e', marginBottom: '0px' }}
                >
                    Delete All Worker Grading Records
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure you wish to delete all {numOfRows} workers' performance grading records?</Modal.Body>
            <Modal.Footer>
                <Button variant='danger' onClick={onDelete}>
                    Delete All
                </Button>
                <Button variant='outline-secondary' onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteConfirmationModal;
